/* eslint-disable @typescript-eslint/no-var-requires */
import React, { ReactElement, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Image from '@sport1/react-elements/Image'
import Touchable from '@sport1/react-elements/Touchable'
import { LogoTypes } from '../LogoInterfaces'
import { TestID } from '../../../utils/PropTypesDefinitions'
import LinkProps from '../../../Link/LinkProps'

export type LogoProps = {
    type?: LogoTypes
    onPress?: () => void
    href?: string
    width: number
} & LinkProps &
    TestID

const ON_LIGHT = require('../../../assets/logos/Sport1Plus/OnLight.svg')
const ON_DARK = require('../../../assets/logos/Sport1Plus/OnDark.svg')

const Sport1PlusLogo = ({
    type = 'OnLight',
    width,
    onPress,
    href,
    testID,
    webRel,
}: LogoProps): ReactElement => {
    const imageUrl = type === 'OnLight' ? ON_LIGHT : ON_DARK
    const aspect = 51 / 229
    const height = width * aspect

    return (
        <Grid horizontal noExpand testID={testID}>
            <Touchable disableHover onPress={onPress} href={href} webRel={webRel}>
                <Image src={imageUrl} width={width} height={height} />
            </Touchable>
        </Grid>
    )
}

export default memo(Sport1PlusLogo)
